import React, { useState, useEffect } from 'react'
import { NavLink, useHistory, Switch, Route, Redirect } from 'react-router-dom'
import { Chip } from '@arnsbogroup/react-voicearchive'
import classNames from 'classnames'

const Tabs = ({ tabs, tabsClassName, childrenClassName, ...props }) => {
  const history = useHistory()

  const [chips, setChips] = useState({})

  tabs = tabs.filter(tab => tab !== null);

  useEffect(() => {
    setChips(
      tabs.reduce((memo, { chip }, i) => {
        if (chip) {
          memo[i] = chip
        }
        return memo
      }, {})
    )
  }, [])

  const setTabChip = (i) => (chip) => {
    setChips((prev) => ({ ...prev, [i]: chip }))
  }

  return (
    <div {...props}>
      <div className={classNames('lg:hidden', tabsClassName)}>
        <label htmlFor="selected-tab" className="sr-only">Select tab</label>
        <select
          name="selected-tab"
          className="mt-1 block w-full pl-0 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-primary focus:border-primary sm:text-sm rounded-sm"
          onChange={({ target: { value } }) => history.push(value)}
        >
          { tabs.map(({ to, message }, i) => (
            <option key={`${to}-sm`} value={to}>{ message } { chips[i] && `(${chips[i]})`}</option>
          )) }
        </select>
      </div>

      <div className={classNames('hidden lg:block border-b border-gray-200', tabsClassName)}>
        <nav className="-mb-px flex text-gray-500 space-x-3 overflow-x-auto">
          { tabs.map(({ to, message }, i) => (
            <NavLink
              key={`${to}-lg`}
              exact
              to={to}
              activeClassName="border-primary text-primary-darker"
              className="hover:border-gray-300 hover:text-gray-700 whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm"
            >
              { message } { chips[i] }
            </NavLink>
          )) }
        </nav>
      </div>

      <div className={childrenClassName}>
        <Switch>
          { tabs.map(({ to, route: { component: Component, render, ...route } }, i) => (
            <Route
              key={to}
              render={render ? (props) => render({ ...props, setTabChip: setTabChip(i) }) : undefined}
              component={Component ? (props) => <Component {...props} setTabChip={setTabChip(i)} /> : undefined}
              {...route}
            />
          )) }
          <Route path="*">
            <Redirect to={tabs[0].to} />
          </Route>
        </Switch>
      </div>
    </div>
  )
}

export default Tabs
